import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(() => {
        try {
            const saved = window.localStorage.getItem("omar-portfolio-lang");
            if (saved === "en" || saved === "de") return saved;
            const browserLang = (navigator.language || "en").slice(0, 2);
            return browserLang === "de" ? "de" : "en";
        } catch {
            return "en";
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem("omar-portfolio-lang", language);
        } catch {
            /* ignore storage errors */
        }
        document.documentElement.setAttribute("lang", language);
    }, [language]);

    const toggleLanguage = () => setLanguage((prev) => (prev === "en" ? "de" : "en"));

    const value = useMemo(
        () => ({
            language,
            setLanguage,
            toggleLanguage,
            t: translations[language],
        }),
        [language]
    );

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
    return ctx;
}
